import { useCallback, useState } from 'react';

interface PaginationArgs {
	pageNumber: number;
	pageSize: number;
}

export default function usePaginationArgs() {
	const [paginationArgs, setPaginationArgs] = useState<Partial<PaginationArgs>>();

	const onPageChange = useCallback((pageNumber: number) => {
		setPaginationArgs((state) => ({ ...state, pageNumber }));
	}, []);

	const onSizePerPageChange = useCallback((pageSize: number) => {
		setPaginationArgs((state) => ({ ...state, pageSize }));
	}, []);

	return {
		...paginationArgs,
		onPageChange,
		onSizePerPageChange,
	};
}
